export default function mergeTicketContact(ticket, contact) {
  return contact && ticket.contactId === contact.id
    ? { ...ticket, contact: { ...ticket.contact, ...contact } }
    : ticket;
}
